import { builder } from '@builder.io/react';

builder.init('67d9d228858940769676d22fc3acbd7b'); // public API key
